module.exports = __webpack_public_path__ + "assets/IncenterDetailed.10118d773208a877077abaa145e6a6d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/IncenterDetailed.png
// module id = 524
// module chunks = 0